import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import { MapPin } from 'lucide-react';
import Reveal, { ChapterLabel } from './Reveal';
import { COMPANY } from '../data/site';

const TEAM_IMG = 'https://images.unsplash.com/photo-1600518464441-9154a4dea21b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200';

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const y = useTransform(scrollYProgress, [0, 1], [60, -60]);

  return (
    <section id="ueber-uns" data-testid="about-section" ref={ref} className="overflow-hidden bg-white py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
        <div className="relative order-2 lg:order-1">
          <motion.div style={{ y }} className="relative">
            <div className="overflow-hidden rounded-[2rem] shadow-2xl shadow-navy/15">
              <img
                src={TEAM_IMG}
                alt="Team von F&M Umzüge & Entrümpelung beim Verladen"
                loading="lazy"
                className="aspect-[4/3] w-full object-cover"
                data-testid="about-image"
              />
            </div>
            <div className="absolute -bottom-8 -right-4 rounded-2xl bg-navy p-6 shadow-xl sm:-right-8" data-testid="about-badge">
              <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-brand">{COMPANY.short}</p>
              <p className="mt-1 font-display text-2xl font-extrabold text-white">{COMPANY.slogan}</p>
            </div>
          </motion.div>
        </div>

        <div className="order-1 lg:order-2">
          <ChapterLabel index="02" title="Über uns" />
          <Reveal delay={0.1} className="mt-8">
            <h2 className="font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl lg:text-5xl">
              Ein Team, das <span className="text-brand">anpackt</span> – statt nur zu versprechen.
            </h2>
          </Reveal>
          <Reveal delay={0.2} className="mt-6 space-y-5 text-base leading-relaxed text-slate-600">
            <p>
              F&M Umzüge & Entrümpelung ist Ihr zuverlässiger Partner in Berlin &
              Brandenburg. Ob privater Umzug, gewerblicher Transport oder
              komplette Haushaltsauflösung: Wir übernehmen die schwere Arbeit –
              termingerecht, sorgfältig und zu fairen, transparenten Preisen.
            </p>
            <p>
              Bei uns sprechen Sie direkt mit den Menschen, die später auch bei Ihnen
              vor der Tür stehen. Persönlich, ehrlich und ohne versteckte Kosten.
            </p>
          </Reveal>
          <Reveal delay={0.3} className="mt-8">
            <div className="inline-flex items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-5 py-4">
              <MapPin className="h-5 w-5 shrink-0 text-brand" />
              <p className="text-sm font-medium text-slate-700">
                {COMPANY.street}, {COMPANY.city}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
